import catalog from "./operatorIntegrations.json" with { type: "json" };

export type OperatorIntegrationAuth = "none" | "oauth" | "header";
export type OperatorIntegrationCategory =
  | "Finance"
  | "Legal"
  | "Marketing"
  | "Product"
  | "Research"
  | "Sales";

export type OperatorIntegrationCatalogEntry = {
  readonly category: OperatorIntegrationCategory;
  readonly subcategory: string;
  readonly id: string;
  readonly name: string;
  readonly description: string;
  readonly url: string;
  readonly auth: OperatorIntegrationAuth | null;
  readonly oneClick: boolean;
  readonly limitation?: string;
  readonly publisher: string;
  readonly tags: readonly string[];
  readonly priority: "P0" | "P1" | "P2";
  readonly logo: string;
  readonly sourceUrl: string;
  readonly publisherUrl: string;
};

export type OperatorIntegration = OperatorIntegrationCatalogEntry & {
  readonly auth: OperatorIntegrationAuth;
  readonly oneClick: true;
};

export const OPERATOR_INTEGRATION_CATALOG =
  catalog.integrations as ReadonlyArray<OperatorIntegrationCatalogEntry>;

export const OPERATOR_INTEGRATIONS: ReadonlyArray<OperatorIntegration> =
  OPERATOR_INTEGRATION_CATALOG.filter(
    (entry): entry is OperatorIntegration =>
      entry.oneClick &&
      !entry.limitation &&
      (entry.auth === "none" || entry.auth === "oauth" || entry.auth === "header"),
  );
